import { QueryCache, QueryClient } from '@tanstack/react-query';

import { isApiError } from '@/api/client';
import { queryKeys } from '@/api/keys';

/**
 * Conventions: queries retry once on network/5xx only; 4xx are final. Mutations never retry.
 * Any 401 from a member-scoped query marks the session as signed out.
 */
export function createQueryClient() {
  const client: QueryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (
          isApiError(error) &&
          error.status === 401 &&
          query.queryKey[0] !== queryKeys.session[0]
        ) {
          client.setQueryData(queryKeys.session, null);
          client.removeQueries({ queryKey: ['me'] });
        }
      },
    }),
    defaultOptions: {
      queries: {
        retry: (count, error) =>
          !(isApiError(error) && error.status >= 400 && error.status < 500) && count < 1,
        refetchOnWindowFocus: false,
        staleTime: 10_000,
      },
      mutations: { retry: false },
    },
  });
  return client;
}
